export default {
	chufadimudidi: '出発地/目的地',
	xiugaisouxun: '検索を絞り込む',
	you: '出発',
	xianshi: '表示',
	jieguo: '結果',
	paixufangshi: '並び替え',
	zuipianyi: '最安',
	zuikuai: '最速',
	tuiguang: 'おすすめ',
	tingzhan: '乗換',
	tingzhanyi: '乗換1回',
	zhifei: '直行便（乗換なし）',
	yigetingzhan: '乗換1回',
	duoguoliangge: '2回以上の乗換',
	meiyouchangshijian: '長時間の待機なし',
	shaoyusixiaoshi: '4時間未満',
	jiagefanwei: '価格帯',
	hanshui: '税込み',
	hangbanshikebiao: 'フライト時刻表',
	tingliushijian: '所要時間',
	tingliu: '所要時間',
	hangkonggongsi: '航空会社',
	lianmeng: '航空連合',
	jiebo: 'シャトルバス',
	zongjia: '合計金額',
	xianzaiyuding: '今すぐ予約',
	chakantanpai: 'CO2の表示',
	shengyu: '残り',
	gezouwei: '残りの席',
	zongfeixingshijian: '総所要時間',
	feixingshijian: 'フライト時間',
	hangbanxiangxixinxi: 'フライト詳細',
	xianshigengduo: 'さらに表示',
	quanxuan: 'すべて選択',
	qingchu: 'クリア',
	xuanzenindefukuanfangshi: 'お支払い方法を選択',
	xinyongkajiejika: 'クレジット/デビットカード',
	qingshurunindexiangxixinxi: 'クレジット/デビットカードの詳細を入力してください',
	youxiaoriqi: '有効期限',
	xinyongkajiejikakahao: 'クレジット/デビットカード番号',
	kayanzhengma: 'カード検証番号',
	yanzhengmatishi: '署名パネルまたはカードの裏側に表示されている3桁のセキュリティコード（CVC2）です。',
	dianziyoujian: '電子メールアドレス（オプション）',
	lijifukuan: '今すぐ支払う',
	quxiaobingfanhui: 'キャンセルして戻る',
	wuxiaoka: '無効なカード',
	yichang: "状態異常、銀行カスタマーサービスに連絡して解決してください",
	jiagefashengbiandong: '価格が変動し、フライトを再照会しています',
	ren: '人',
	chengkepingjunjiage: '乗客1人あたりの平均価格',
};
